import Icon from '../components/Icon.vue'

Icon.register({"caret-left":{"width":192,"height":512,"paths":[{"d":"M192 127.3V384.7C192 402.5 170.5 411.4 157.9 398.8L29.2 270.1C21.4 262.3 21.4 249.7 29.2 241.9L157.9 113.2C170.5 100.6 192 109.5 192 127.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-left.js
// module id = bfpj
// module chunks = 0